var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 10,
    viewBox: "0 0 13 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7208 0.981934C12.5347 0.797026 12.2831 0.693237 12.0208 0.693237C11.7585 0.693237 11.5068 0.797026 11.3208 0.981934L4.99279 7.30293L2.18679 4.49493C2.00008 4.30809 1.74679 4.20307 1.48264 4.20297C1.2185 4.20288 0.965133 4.30772 0.778288 4.49443C0.591443 4.68114 0.486422 4.93443 0.486328 5.19858C0.486234 5.46272 0.591076 5.71609 0.777788 5.90293L4.28679 9.41293C4.37901 9.50524 4.48852 9.57847 4.60906 9.62843C4.7296 9.6784 4.8588 9.70412 4.98929 9.70412C5.11977 9.70412 5.24898 9.6784 5.36952 9.62843C5.49006 9.57847 5.59957 9.50524 5.69179 9.41293L12.7168 2.38693C12.8094 2.29497 12.8829 2.18567 12.9332 2.06528C12.9835 1.94488 13.0096 1.81574 13.01 1.68526C13.0103 1.55477 12.985 1.4255 12.9354 1.30482C12.8858 1.18414 12.8128 1.07442 12.7208 0.981934Z",
    fill: "#736562"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.cbb197d8c896320cde52475e46a48bfb.svg";
export { ForwardRef as ReactComponent };